import { render, staticRenderFns } from "./basic-action.vue?vue&type=template&id=22408c3f"
import script from "./basic-action.vue?vue&type=script&lang=js"
export * from "./basic-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports